

import React, { useState } from "react";
import { useHistory } from "../../utils/router";
import { toast, getLink } from "../../utils/helpers";
import CompraRecurrenteForm from "./Form";
import { postRequest } from "../../utils/request";

const Create = () => {
    const history = useHistory();
    const [contacto, setContacto] = useState(null);
    const [saving, setSaving] = useState(false);
    const [errors, setErrors] = useState({});

    const handleSubmit = async (e) => {
        setSaving(true);
        setErrors({});

        const formData = new FormData(e.target);

        try {
            const response = await postRequest("compras-recurrentes", formData);
            
            if (response.success) {
                toast("Compra recurrente creada con éxito");
                history.push(getLink("/compras-recurrentes"));
            } else {
                setErrors(response.data.message || {});
                toast("Error al crear compra recurrente", "error");
            }
        } catch (e) {
            console.error(e);
            toast("Error de red", "error");
        }
        setSaving(false);
    };

    return (
        <div className="crear-compra">
            <div className="page-header">
                <h1 className="page-title row">
                    <div className="col">
                        <span className="m-r-15">Nueva Compra Recurrente</span>
                    </div>
                </h1>
            </div>
            <CompraRecurrenteForm onSubmit={handleSubmit} saving={saving} errors={errors} contacto={contacto} updateContacto={setContacto} />
        </div>
    );
};

export default Create;
